export const table = {
  editFlow: 'Edit configuration template',
  editFlowPackages: 'Preview packages',
  copyFlow: 'Copy configuration template',
  editStages: 'Preview stages',
  deleteFlow: 'Delete configuration template',
  viewFlow: 'View configuration template',
  editFlowData: 'Edit configuration template data',

  previewFlowPackages: 'Preview packages',
  previewStages: 'Preview stages',
  previewFlowData: 'Preview configuration template data',
} as const
